// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"396af80a18156c0b","5318":"2d457693be4b2b69","9777":"d8486382ea80e1b9"}[chunkId] + ".js";
};